import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { RichToolTipDirective } from 'src/app/directives/rich-tool-tip.directive';
import { AttributeOptions } from 'src/app/models/attribute-options';
import { AttributeOptionsDialogData } from './models/attribute-options-dialog-data';
import { AttributeOptionsDialogResult } from './models/attribute-options-dialog-result';

@Component({
    selector: 'app-attribute-options-dialog',
    imports: [
        MatCardModule,
        FormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        CommonModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        MatCheckboxModule,
        MatTooltipModule,
        RichToolTipDirective,
    ],
    templateUrl: './attribute-options-dialog.html',
    styleUrl: './attribute-options-dialog.scss'
})
export class AttributeOptionsDialogComponent implements OnInit {
    /**
     * Liste des icônes utilisées par le template
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Formulaire de l'action.
     */
    formGroup: FormGroup;

    /**
     * Controles du formulaire.
     */
    public trimPastedTextFormControl: UntypedFormControl = new UntypedFormControl(null);
    public removeSpaceFromPastedTextFormControl: UntypedFormControl = new UntypedFormControl(null);

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<AttributeOptionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AttributeOptionsDialogData
    ) {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.formGroup = new UntypedFormGroup({
            trimPastedText: new UntypedFormControl({ value: '' }),
            removeSpaceFromPastedText: new UntypedFormControl({ value: '' }),
        });

        if (this.data.readonly) {
            this.formGroup.get('trimPastedText').disable();
            this.formGroup.get('removeSpaceFromPastedText').disable();
        }

        this.fillForm(this.data.item);
    }

    /**
     * Appellé lorsque l'utilisateur valide le formulaire.
     */
    onConfirm(): void {
        this.RetrieveValueFromForm();
        let result: AttributeOptionsDialogResult = { status: true, item: this.data.item };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    /**
     * Appellé lorsque l'utilisateur annule le formulaire.
     */
    onCancel(): void {
        let result: AttributeOptionsDialogResult = { status: false, item: this.data.item };
        // Close the dialog, return false
        this.dialogRef.close(result);
    }

    /**
     * Retourne les options de l'attribut à partir des champs du formulaire.
     */
    private RetrieveValueFromForm() {
        this.data.item.trimPastedText = this.formGroup.get('trimPastedText').value;
        this.data.item.removeSpaceFromPastedText = this.formGroup.get('removeSpaceFromPastedText').value;
    }

    /**
     * Remplit les champs du formulaire avec les options de l'attribut.
     */
    private fillForm(item: AttributeOptions) {
        this.formGroup.get('trimPastedText').setValue(item.trimPastedText);
        this.formGroup.get('removeSpaceFromPastedText').setValue(item.removeSpaceFromPastedText);
    }
}
